import { forwardRef } from "react";

import Icon from "@/components/Icon";
import LunaPeekingSideRight from "./LunaPeekingSideRight.svg.jsx";
import LunaPeekingSideLeft from "./LunaPeekingSideLeft.svg.jsx";
import LunaPeekingSideIdeaLeft from "./LunaPeekingSideIdeaLeft.svg.jsx";
import type { IconProps } from "@/components/Icon/Icon";

const LunaPeekingSideIcon = forwardRef<
  SVGSVGElement,
  Omit<IconProps, "SvgComponent"> & { right?: boolean; idea?: boolean }
>(({ right, idea, ...rest }, ref) => {
  const getIconVariant = () => {
    if (idea) return LunaPeekingSideIdeaLeft;
    return right ? LunaPeekingSideRight : LunaPeekingSideLeft;
  };
  return <Icon ref={ref} SvgComponent={getIconVariant()} {...rest} />;
});

export default LunaPeekingSideIcon;
